import { PaginationProps } from "./types";

const usePagination = ({
  currentPage,
  totalPages,
  onPageChange,
  pageItemsToShow,
}: PaginationProps) => {
  const getPageNumbers = (
    pageNumber: number,
    minNumber: number = 0
  ): number[] => {
    if (totalPages <= pageItemsToShow) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (
      (pageNumber === 1 &&
        totalPages - pageItemsToShow < pageItemsToShow &&
        currentPage > pageItemsToShow) ||
      (currentPage <= totalPages - pageItemsToShow + 1 &&
        pageNumber === totalPages)
    ) {
      return [pageNumber];
    }

    const half = Math.floor(pageItemsToShow / 2);
    const startNumber = Math.max(1, pageNumber - half);
    let startPage = startNumber > minNumber ? startNumber : minNumber + 1;
    let endPage = Math.min(totalPages, pageNumber + half);

    if (endPage - startPage + 1 < pageItemsToShow) {
      if (startPage === 1) {
        endPage = Math.min(totalPages, pageItemsToShow);
      } else {
        startPage = Math.max(
          1,
          totalPages - pageItemsToShow + 1,
          minNumber + 1
        );
      }
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  };

  const handlePageChange = (page: number) => {
    if (page !== currentPage) onPageChange(page);
  };

  const isCurentPageInLastOrFirst =
    currentPage < pageItemsToShow ||
    currentPage > totalPages - (pageItemsToShow - 1);

  const isCurrentPageInMiddle =
    currentPage >= pageItemsToShow &&
    currentPage <= totalPages - pageItemsToShow + 1;

  const firstNumbersGroup = getPageNumbers(1);

  const lastNumbersGroup = getPageNumbers(
    totalPages,
    firstNumbersGroup[firstNumbersGroup.length - 1]
  );

  const middleNumbers = getPageNumbers(currentPage);

  return {
    handlePageChange,
    isCurentPageInLastOrFirst,
    isCurrentPageInMiddle,
    firstNumbersGroup,
    lastNumbersGroup,
    middleNumbers,
  };
};

export default usePagination;
